import React, { useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { useLocalization } from "../../contexts/LocalizationContext";

const PaymentModal = ({ open, onClose, paymentResponse }) => {
  const [buyModal, setBuyModal] = useState(open);

  const { theme } = useTheme();
  const { t } = useLocalization();

  const confirmOpenPaymentLink = () => {
    if (!paymentResponse.paymentUrl) return;
    try {
      console.log(
        "[Payment][Profile] Opening payment link:",
        paymentResponse?.paymentUrl,
      );
      const normalizeUrl = (u) => {
        if (!u) return null;
        const trimmed = String(u).trim();
        if (/^https?:\/\//i.test(trimmed)) return trimmed;
        if (/^www\./i.test(trimmed)) return `https://${trimmed}`;
        return `https://${trimmed}`;
      };
      const url = normalizeUrl(paymentResponse?.paymentUrl);
      window.open(url, "_blank");
      setBuyModal(false);
    } catch (e) {
      console.log("[Payment][Profile] Error opening payment link:", e);
    }
  };

  const BasicModal = ({
    icon,
    open,
    title,
    text,
    onCancel,
    onConfirm,
    cancelText,
    confirmText,
  }) => {
    if (!open) return null;
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.35)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            backgroundColor: theme.surface,
            borderRadius: "12px",
            padding: "25px",
            maxWidth: "500px",
            width: "90%",
            border: `1px solid ${theme.border}`,
          }}
        >
          <div
            style={{
              backgroundColor: theme.surface,
              display: "flex", // Add this line
              flexDirection: "row",
              alignItems: "center",
              gap: "12px",
            }}
          >
            {icon && (
              <div style={{ fontSize: 24, marginBottom: "10px" }}>{icon}</div>
            )}
            <div
              style={{ fontSize: 24, fontWeight: 700, marginBottom: "10px" }}
            >
              {title}
            </div>
          </div>
          {text && (
            <div
              style={{
                fontSize: 16,
                color: theme.textSecondary,
                marginBottom: 20,
                whiteSpace: "pre-line", // Add this line
                lineHeight: "25px",
              }}
            >
              {text}
            </div>
          )}
          <div
            style={{
              height: "1px",
              // backgroundColor: theme.border,
              margin: "12px 0", // Adjust spacing as needed
              backgroundColor: "cadetblue",
            }}
          />
          <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
            <button
              style={{
                backgroundColor: "unset",
                border: "none",
                color: "indianred",
                marginRight: "12px",
                padding: "8px 16px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onClick={onCancel}
            >
              <p style={{ fontSize: 16, fontWeight: 600 }}>
                {cancelText || "Cancel"}
              </p>
            </button>
            <button
              className="modal-primary-button modal-button-glow"
              style={{
                backgroundColor: "cadetblue",
                border: "none",
                color: "white",
                marginRight: "12px",
                padding: "8px 16px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                fontWeight: "600",
                fontSize: "16px",
                boxShadow: "0 2px 8px rgba(95, 158, 160, 0.3)",
              }}
              onClick={onConfirm}
            >
              {confirmText || "OK"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {/* Buy subscription confirmation */}
      {buyModal && (
        <BasicModal
          icon={
            <svg
              width="60"
              height="60"
              viewBox="0 0 512 512"
              fill="#000000"
              x="0px"
              y="0px"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  style={{ fill: "#7bc4db" }}
                  d="M486.881,362.002H281.653c-9.446,0-17.102-7.656-17.102-17.102V216.633 c0-9.446,7.656-17.102,17.102-17.102h205.228c9.446,0,17.102,7.656,17.102,17.102V344.9 C503.983,354.346,496.327,362.002,486.881,362.002z"
                ></path>
                <path
                  style={{ fill: "#F0C087" }}
                  d="M291.834,291.014l-65.353-10.892c-11.031-1.839-17.359-13.596-12.817-23.815l18.463-41.541 c4.117-9.264,13.305-15.234,23.443-15.234h26.084h68.409l-17.153-22.87c-5.443-7.258-13.546-12.055-22.527-13.338l-89.074-12.725 c-10.867-1.553-21.954-0.087-32.044,4.238L99.496,193.31c-7.353,3.151-15.136,5.473-23.07,6.223h-0.003h-8.548V327.8h220.915 c10.227,0,18.518-8.29,18.518-18.518C307.307,300.228,300.762,292.502,291.834,291.014z"
                ></path>
                <path
                  style={{ fill: "#E6AF78" }}
                  d="M102.079,192.201l-2.582,1.107c-7.354,3.151-15.136,5.473-23.071,6.223h-0.004h-8.547v128.267h34.205 V192.201z"
                ></path>
                <g>
                  <path
                    style={{ fill: "#ddc988" }}
                    d="M307.307,242.286h25.653c4.722,0,8.551,3.829,8.551,8.551v17.102c0,4.722-3.829,8.551-8.551,8.551 h-25.653c-4.722,0-8.551-3.829-8.551-8.551v-17.102C298.756,246.115,302.585,242.286,307.307,242.286z"
                  ></path>
                  <circle
                    style={{ fill: "#ddc988" }}
                    cx="452.676"
                    cy="259.388"
                    r="17.102"
                  ></circle>
                </g>
                <circle
                  style={{ fill: "#f87c7c" }}
                  cx="418.472"
                  cy="259.388"
                  r="17.102"
                ></circle>
                <path
                  style={{ fill: "#E4EAF8" }}
                  d="M16.568,336.349h51.307c4.722,0,8.551-3.829,8.551-8.551V199.531c0-4.722-3.829-8.551-8.551-8.551 H16.568c-4.722,0-8.551,3.829-8.551,8.551v128.267C8.017,332.52,11.845,336.349,16.568,336.349z"
                ></path>
                <path d="M418.472,302.679H401.37c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017C426.489,306.268,422.899,302.679,418.472,302.679z"></path>
                <path d="M469.779,302.679h-17.102c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017C477.795,306.268,474.206,302.679,469.779,302.679z"></path>
                <path d="M367.165,302.679h-17.102c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017C375.182,306.268,371.592,302.679,367.165,302.679z"></path>
                <path d="M349.528,267.94v-17.102c0-9.136-7.432-16.568-16.568-16.568h-25.653c-9.136,0-16.568,7.432-16.568,16.568v17.102 c0,9.136,7.432,16.568,16.568,16.568h25.653C342.096,284.508,349.528,277.076,349.528,267.94z M333.495,267.94 c0,0.295-0.239,0.534-0.534,0.534h-25.653c-0.295,0-0.534-0.239-0.534-0.534v-17.102c0-0.295,0.239-0.534,0.534-0.534h25.653 c0.295,0,0.534,0.239,0.534,0.534V267.94z"></path>
                <path d="M452.676,234.27c-6.603,0-12.614,2.564-17.102,6.745c-4.488-4.18-10.5-6.745-17.102-6.745 c-13.851,0-25.119,11.268-25.119,25.119c0,13.851,11.268,25.119,25.119,25.119c6.603,0,12.614-2.564,17.102-6.745 c4.488,4.18,10.5,6.745,17.102,6.745c13.851,0,25.119-11.268,25.119-25.119S466.527,234.27,452.676,234.27z M418.472,268.474 c-5.01,0-9.086-4.076-9.086-9.086c0-5.01,4.076-9.086,9.086-9.086s9.086,4.076,9.086,9.086 C427.557,264.399,423.482,268.474,418.472,268.474z M452.676,268.474c-5.01,0-9.086-4.076-9.086-9.086 c0-5.01,4.076-9.086,9.086-9.086s9.086,4.076,9.086,9.086C461.762,264.399,457.686,268.474,452.676,268.474z"></path>
                <path d="M486.881,191.514h-132.81l-14.748-19.663c-6.767-9.023-16.642-14.869-27.806-16.464l-89.074-12.725 c-12.328-1.758-24.891-0.098-36.336,4.807l-89.769,38.473c-4.723,2.024-9.64,3.498-14.674,4.425 c-2.973-4.457-8.042-7.402-13.79-7.402H16.568C7.432,182.964,0,190.396,0,199.532v128.267c0,9.136,7.432,16.568,16.568,16.568 h51.307c6.228,0,11.659-3.458,14.489-8.551h174.171v9.086c0,13.851,11.268,25.119,25.119,25.119h205.228 c13.851,0,25.119-11.268,25.119-25.119V216.634C512,202.782,500.732,191.514,486.881,191.514z M102.654,200.676l89.769-38.473 c8.74-3.745,18.338-5.015,27.753-3.671l89.074,12.725c6.925,0.989,13.049,4.615,17.247,10.212l7.533,10.043h-78.46 c-13.293,0-25.369,7.849-30.768,19.996l-18.463,41.54c-3.18,7.154-2.875,15.211,0.835,22.106 c3.71,6.894,10.267,11.587,17.991,12.874l65.353,10.892c5.085,0.847,8.775,5.203,8.775,10.358c0,5.79-4.711,10.501-10.501,10.501 H84.443V206.155C90.69,205.015,96.793,203.188,102.654,200.676z M256.534,277.004l-28.736-4.789 c-2.793-0.466-5.165-2.162-6.507-4.656c-1.341-2.494-1.452-5.409-0.301-7.995l18.463-41.541c2.828-6.363,9.154-10.474,16.117-10.474 h2.672c-1.098,2.82-1.707,5.882-1.707,9.086V277.004z M67.875,328.332H16.568c-0.295,0-0.534-0.239-0.534-0.534V199.531 c0-0.295,0.239-0.534,0.534-0.534h51.307c0.295,0,0.534,0.239,0.534,0.534v128.267C68.409,328.093,68.17,328.332,67.875,328.332z M495.967,344.9c0,5.01-4.076,9.086-9.086,9.086H281.653c-5.01,0-9.086-4.076-9.086-9.086v-9.086h16.222 c11.31,0,20.984-7.116,24.796-17.102h2.272c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017h-1.374 c-2.544-9.994-10.731-17.806-21.333-19.573l-20.584-3.43v-63.043c0-5.01,4.076-9.086,9.086-9.086h205.228 c5.01,0,9.086,4.076,9.086,9.086V344.9z"></path>
                <circle cx="42.221" cy="301.962" r="8.017"></circle>
              </g>
            </svg>
          }
          type={"payment"}
          open={buyModal}
          title={t("paymentConfirmTitle") || "Підтвердження оплати"}
          text={paymentResponse.messageText || "Купити підписку"}
          onCancel={onClose}
          onConfirm={() => {
            confirmOpenPaymentLink();
          }}
          confirmText={t("pay") || "Оплатити"}
          cancelText={t("cancel") || "Скасувати"}
        />
      )}
    </div>
  );
};

export default PaymentModal;
